import { render } from "./OrderRegiAusToKor.vue?vue&type=template&id=78883006&scoped=true"
import script from "./OrderRegiAusToKor.vue?vue&type=script&lang=js"
export * from "./OrderRegiAusToKor.vue?vue&type=script&lang=js"

import "./OrderRegiAusToKor.vue?vue&type=style&index=0&id=78883006&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78883006"]])

export default __exports__